import { authenticatedAPI } from '../AuthenticatedAPI';
import {
  getBaselineQuestionnaireStateResDto,
  RecordAnonymousQuestionnaireResultReqDto,
  recordAnonymousQuestionnaireResultResDto,
} from '@web/common';

export const getStateOfBaselineSurveyData = async () => {
  return authenticatedAPI.get(
    `/api/questionnaires/baseline`,
    getBaselineQuestionnaireStateResDto,
    {
      timeout: 120_000, // since the first time getting that from the server might take a while
    },
  );
};

export const recordAnonymousQuestionnaireResult = async (
  body: RecordAnonymousQuestionnaireResultReqDto,
) => {
  return authenticatedAPI.post(
    `api/questionnaires/anonymous-record`,
    body,
    recordAnonymousQuestionnaireResultResDto,
  );
};
